import {
  DeviceEnabledType,
  UserAttributeDefs,
  ValidModelType,
} from "@iotv/datamodel-core";
import { PathDirection } from "@iotv/iotv-v3-types";

const typeName = "Storage";

export type StorageProps = {
  purpose?: string;
  capacity?: number;
  currentVolume?: number;
  nearlyFull?: boolean;
  full?: boolean;
  mountHeight?: number;
  // topArea?: number;
  constructionMaterial?: string;
  image?: string;
};

export class Storage extends DeviceEnabledType {
  constructor(ob: any) {
    super(ob.type || typeName, ob);
  }

  purpose?: string;
  capacity?: number;
  nearlyFull?: boolean;
  full?: boolean;
  currentVolume?: number;
  // topArea?: number;
  constructionMaterial?: string;
  image?: string;

  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),
      name: {
        type: "String",
        editable: true,
        label: "Name",
        name: "name",
        description: "Name of storage",
      },
      purpose: {
        type: "String",
        editable: true,
        label: "Purpose",
        name: "purpose",
        description: "Used for",
      },
      nearlyFull: {
        type: "Boolean",
        editable: false,
        label: "Nearly Full",
        name: "Nearly Full",
        description: "Indicator for if the storage entity is nearly filled",
      },
      full: {
        type: "Boolean",
        editable: false,
        label: "Full",
        name: "Full",
        description: "Indicator for if the storage entity is filled",
      },
      capacity: {
        type: "Number",
        editable: true,
        label: "Capacity",
        name: "capacity",
        description:
          "Total volume of Dam, or maximum permitted capacity in m3 and litres",
      },
      // currentVolume: {
      //   type: "Number",
      //   editable: true,
      //   label: "Current Volume",
      //   name: "currentVolume",
      //   description: "The total calculated volume of the Dam",
      // },
      // topArea: {
      //   type: "Number",
      //   editable: true,
      //   label: "Top Area",
      //   name: "topArea",
      //   description: "Area of the top of the Dam in m2",
      // },
      constructionMaterial: {
        type: "String",
        editable: true,
        label: "Construction material",
        name: "constructionMaterial",
        description: "Material dam is contructed from",
      },
      Location: {
        type: "RelatedType",
        editable: false,
        label: "Location",
        name: "Location",
        description: "Boundary points of dam",
        objectTypeId: "Location" as ValidModelType,
        direction: PathDirection.child,
        edgeTypeId: "Dam_has_Location",
      },
      // image: {
      //   type: "String",
      //   editable: true,
      //   label: "Image",
      //   name: "image",
      //   description: "Photograph of dam",
      // },
      comments: {
        type: "String",
        editable: true,
        label: "Comments",
        name: "comments",
        description: "Free text for info ",
      },
    };
  }
}
